module.exports = __webpack_public_path__ + "img/m2_t2_en.f86bfbb4.svg";